import { TGridSteps } from '../themes/types';

const getCssPropsValue = (steps: TGridSteps) => `repeat(${steps}, 1fr)`;

const getGridColumnLayoutValue = (steps: TGridSteps) =>
  Array.isArray(steps) ? steps.map((item) => getCssPropsValue(item)) : getCssPropsValue(steps);

export default getGridColumnLayoutValue;
